import { createContext } from "react";

export default createContext({
    defaultValue: "abc"
});